import { render, staticRenderFns } from "./ScoresAnaliseMunicipios.vue?vue&type=template&id=d6163058&scoped=true&"
import script from "./ScoresAnaliseMunicipios.vue?vue&type=script&lang=js&"
export * from "./ScoresAnaliseMunicipios.vue?vue&type=script&lang=js&"
import style0 from "./ScoresAnaliseMunicipios.vue?vue&type=style&index=0&id=d6163058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6163058",
  null
  
)

export default component.exports